import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Card, Typography, List, ListItem, ListItemText, ListItemAvatar, Avatar, Rating, Box, Grid, Paper } from '@mui/material';
import Header1 from '../Header/Header1';
import Footer2 from '../Footer/Footer2';

const API_URL = process.env.REACT_APP_API_URL;

const UserFeedbacks = ({ userId, onLogout }) => {

  useEffect(() => {
    window.scrollTo(0, 0);  // Scroll to top when this page is loaded
  }, []);

  
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.post(`${API_URL}/user/details/`, { user_id: userId })
      .then((response) => {
        setUserData(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("There was an error fetching user data!", error);
        setLoading(false);
      });
  }, [userId]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!userData) {
    return <div>No user data available.</div>;
  }

  // Helper function to render star ratings
  const renderStars = (rating) => {
    return (
      <Box display="flex" alignItems="center">
        <Rating name="read-only" value={rating} precision={0.5} readOnly />
        <Typography variant="body2" color="textSecondary" sx={{ ml: 1 }}>
          {rating} / 5
        </Typography>
      </Box>
    );
  };

  // Filter out ratings and comments that are null or empty
  const validRatingsComments = userData.ratings_comments.filter(
    (item) => item.comment && item.rating !== null && item.comment.trim() !== ""
  );

  return (
    <div>
      <Typography
        variant="h3"
        component="h1"
        align="center"
        fontSize={{ xs: '2rem', sm: '2.5rem', md: '3rem' }}
        sx={{
          backgroundImage: 'linear-gradient(45deg, #ff00ff, #00bfff)',
          mt: 10,
          letterSpacing: 7,
          WebkitBackgroundClip: 'text',
          color: 'transparent',
        }}
        gutterBottom
      >
        Feedbacks
      </Typography>

      <Box sx={{ mt: 5, px: 2 }}>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Paper sx={{ padding: 3, backgroundColor: '#000000', borderRadius: 2 }}>
              <Typography
                variant="h4"
                sx={{ fontWeight: 'bold', color: 'primary.main', letterSpacing: 5 }}
              >
                {userData.user_details.name} {userData.user_details.surname}
              </Typography>
              <Typography variant="h6" color="textSecondary" sx={{ mt: 1, letterSpacing: 4, }}>
                Avg Rating:
              </Typography>
              {renderStars(userData.user_details.rating)}

              <Box sx={{ mt: 3 }}>
                <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, letterSpacing: 4, }}>
                  Reviews:
                </Typography>

                <List>
                  {validRatingsComments.length > 0 ? (
                    validRatingsComments.map((item, index) => (
                      <ListItem
                        key={index}
                        sx={{
                          mb: 2,
                          padding: 1,
                          borderRadius: '8px',
                          '&:hover': { backgroundColor: '#000000' },
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'flex-start',
                        }}
                      >
                        <ListItemAvatar>
                          <Avatar sx={{ bgcolor: 'primary.main' }}>
                            {item.user_name[0]}
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          primary={
                            <Box display="flex" alignItems="center">
                              <Link to={`/public-view-user/${item.user_id}`} style={{ textDecoration: "none" }}>
                                <Typography variant="body1" sx={{ fontWeight: 'bold', mr: 1, letterSpacing: 3, }}>
                                  {item.user_name} {item.user_surname} :
                                </Typography>
                              </Link>
                              {renderStars(item.rating)}
                            </Box>
                          }
                          secondary={<Typography sx={{ letterSpacing: 1.5 }}>
                          {item.comment}
                        </Typography>}
                        />
                      </ListItem>
                    ))
                  ) : (
                    <Typography variant="body2" color="textSecondary" sx={{ mt: 2, letterSpacing: 2, }}>
                      No reviews yet.
                    </Typography>
                  )}
                </List>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Box>

    </div>
  );
};

export default UserFeedbacks;
